<template>
  <div>
    <sys-data-table
      v-model="selecionados"
      :headers="headers"
      :items="desserts"
      :search="pesquisar"
      :fixed-header="true"
      :height="alturaDaJanela - 170"
      :item-height="40"
      :loading="loading"
      item-key="id"
    >
      <template #top>
        <v-spacer />

        <v-text-field
          v-model="pesquisar"
          append-icon="mdi-magnify"
          label="Pesquisa"
          dense
          clearable
          outlined
          hide-details
          class="my-2"
          style="max-width: 450px;"
        />

        <NovoModulo
          @atualizar-tela-inicial-menu-configuracao-modulo="atualizarModulos()"
        />
      </template>

      <template #item.icon="{ value }"><v-icon>{{ value }}</v-icon></template>

      <template #item.editar="{ item }">
        <EditarModulo
          v-model="item"
          @atualizar-tela-inicial-menu-configuracao-modulo="atualizarModulos()"
        />
      </template>

      <template #item.deletar="{ item }">
        <DeletarModulo
          v-model="item"
          @atualizar-tela-inicial-menu-configuracao-modulo="atualizarModulos()"
        />
      </template>
    </sys-data-table>
  </div>
</template>

<script>
import NovoModulo from './Dialog/NovoModulo.vue';
import EditarModulo from './Dialog/EditarModulo.vue';
import DeletarModulo from './Dialog/DeletarModulo.vue';
import Responsividade from '@/helpers/ResponsiveHeight';
import { buscarModulosConfiguracaoMenuParametrizacao } from "../Api";
export default {
  mixins: [Responsividade],
  components: {
    NovoModulo,
    EditarModulo,
    DeletarModulo
  },
  data: () => ({
    headers: [
      { text: 'ID', value: 'id', style: { width: '60px'}},
      { text: 'Icone', value: 'icon', style: { width: '50px'} },
      { text: 'Modulo', value: 'descricao' },
      { text: 'Link', value: 'link' },
      { text: '', value: 'editar', style: { width: '35px'}},
      { text: '', value: 'deletar', style: { width: '35px'}}
    ],
    desserts: [],
    pesquisar: '',
    selecionados: [],
    loading: true
  }),
  mounted() {
    this.buscarModulos();
  },
  methods: {
    buscarModulos() {
      this.$store.dispatch(
        'loading/addRequisicao',
        buscarModulosConfiguracaoMenuParametrizacao()
          .then((modulos) => this.desserts = modulos)
          .catch(() => this.Helpers.logout())
          .finally(() => this.loading = false)
      )
    },
    atualizarModulos() {
      this.desserts = [];
      this.loading = true;
      this.buscarModulos();
    }
  }
}
</script>

<style>

</style>
